export default __webpack_public_path__ + "static/media/bg-mobile.53a34641.png";